import { Injectable } from '@angular/core';
import { LocalStorageKeys } from 'src/app/configs/local-storage-keys-config';

@Injectable({
  providedIn: 'root',
})
export class AuthTokenService {
  constructor() {}

  //#region accessToken
  static setAccessToken(token, rememberMe?: boolean) {
    if (rememberMe) localStorage.setItem(LocalStorageKeys.accessToken, token);
    else sessionStorage.setItem(LocalStorageKeys.accessToken, token);
  }

  static getAccessToken(): string {
    const tokenInSessionStorage = sessionStorage.getItem(
      LocalStorageKeys.accessToken
    );
    if (tokenInSessionStorage) return tokenInSessionStorage;
    else return localStorage.getItem(LocalStorageKeys.accessToken);
  }

  static clearAccessToken() {
    sessionStorage.removeItem(LocalStorageKeys.accessToken);
    localStorage.removeItem(LocalStorageKeys.accessToken);
  }

  static isExistAccessToken(): boolean {
    if (
      localStorage.getItem(LocalStorageKeys.accessToken) ||
      sessionStorage.getItem(LocalStorageKeys.accessToken)
    )
      return true;

    return false;
  }

  //#endregion

  //#region refreshToken

  static setRefreshToken(token, rememberMe?: boolean) {
    if (rememberMe) localStorage.setItem(LocalStorageKeys.refreshToken, token);
    else sessionStorage.setItem(LocalStorageKeys.refreshToken, token);
  }

  static getRefreshToken(): string {
    const tokenInSessionStorage = sessionStorage.getItem(
      LocalStorageKeys.refreshToken
    );
    if (tokenInSessionStorage) return tokenInSessionStorage;
    else return localStorage.getItem(LocalStorageKeys.refreshToken);
  }

  static clearRefreshToken() {
    sessionStorage.removeItem(LocalStorageKeys.refreshToken);
    localStorage.removeItem(LocalStorageKeys.refreshToken);
  }

  //#endregion

  //#region both

  static clearAllToken() {
    this.clearAccessToken();
    this.clearRefreshToken();
    this.removeActiveOrganizationId();
  }

  static setAllToken(accessToken, refreshToken, rememberMe?: boolean) {
    this.setAccessToken(accessToken, rememberMe);
    this.setRefreshToken(refreshToken, rememberMe);
  }

  //#endregion

  //#region loginWithPanel

  static onSetTokens(accessToken, refreshToken, rememberMe?: boolean) {
    this.clearAllToken();
    this.setAccessToken(accessToken, rememberMe);
    this.setRefreshToken(refreshToken, rememberMe);
  }

  //#endregion

  static isRememberMe(): boolean {
    let result = true;

    const accessTokenInSessionStorage = sessionStorage.getItem(
      LocalStorageKeys.accessToken
    );
    if (accessTokenInSessionStorage) result = false;

    const refreshTokenInSessionStorage = sessionStorage.getItem(
      LocalStorageKeys.accessToken
    );
    if (refreshTokenInSessionStorage) result = false;

    return result;
  }

  static reloadLocalStorage() {
    // get
    const theme = localStorage.getItem('theme');
    const dir = localStorage.getItem('dir');
    const language = localStorage.getItem('language');
    const isVisibleFilterBar = localStorage.getItem('isVisibleFilterBar');
    const activeOrganizationId = localStorage.getItem('activeOrganizationId');

    const ignoreList = [LocalStorageKeys.themeMode];
    const localItems = { ...localStorage };

    Object.keys(localItems).forEach((key) => {
      if (!ignoreList.includes(key as any)) localStorage.removeItem(key);
    });

    // set
    if (theme) localStorage.setItem('theme', theme);
    if (dir) localStorage.setItem('dir', dir);
    if (language) localStorage.setItem('language', language);
    if (isVisibleFilterBar)
      localStorage.setItem('isVisibleFilterBar', isVisibleFilterBar);
    if (activeOrganizationId)
      localStorage.setItem('activeOrganizationId', activeOrganizationId);
  }

  static removeActiveOrganizationId() {
    localStorage.removeItem('activeOrganizationId');
  }
}
